import { createAction } from '@reduxjs/toolkit';

export const fetchCartWishlistSearch = createAction<string>('fetchCartWishlistSearch');
